import usePoolStatus from "./usePoolStatus";
import "./detailpage.scss";
import { POOL_ENDED, POOL_NOT_LIVE } from "../../utils/constants";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const PoolTimerUI = ({ poolstart, poolend, poolsdetail, setPollStatus, setIsDisabled, endedTextColor }) => {
    const { t } = useTranslation();
    const { pollStatus, timeLeft, isDisabled } = usePoolStatus(poolstart, poolend, poolsdetail);
    const poolTimer = pollStatus === POOL_NOT_LIVE ? t("POOL_STARTS_IN") : pollStatus === POOL_ENDED ? t('Ends In') : t('POOL_ENDS_IN')

  useEffect(() => {
    if (pollStatus) {
      setPollStatus(pollStatus);
      setIsDisabled(isDisabled);
    }
  }, [pollStatus]);

    return (
        <div className="single-value">
            <p>{poolTimer}</p>
            {pollStatus === POOL_ENDED ? <h6 style={{ color: endedTextColor ? endedTextColor : "#FE5C32" }}>ENDED</h6> :
                <h6>
                    {timeLeft?.days > 0 && `${timeLeft?.days}d `} {timeLeft?.hours > 0 && `${timeLeft?.hours}h `} {timeLeft?.minutes > 0 && `${timeLeft?.minutes}m `}  {timeLeft?.seconds}s
                </h6>}
        </div>
    );
};

export default PoolTimerUI;
